const config = {
    features: {
      splashCursor: true, // Enables or disables SplashCursor Background Fetaure. Default is set to true. Change to false to disable.
      lineBackground: true, // Enables or disables LineBackground Fetaure. Default is set to true. Change to false to disable.
    },
  };
  
  export default config;
  